/*
 * The CMID was chosen randomly to look like a regular CMID
 * but different enough to not be a real CMID.
 * I.e. the length is not the same as a real CMID.
 */
export const demoOrganizationCmId = '9841223';
